export default "__VITE_ASSET__DBQI$gAj__"